import { store } from '@/store';
import { partnerGotoLink } from '@/helpers';

export const clickOutMixin = {
    data() {
        return {
            storeState: store.state,
        };
    },
    methods: {
        goto(id, p, cT) {
            return partnerGotoLink(
                id,
                p,
                cT,
                this.storeState.psh,
                this.storeState.pageViewId,
                window.canRunAds
            );
        },
    },
};
